/**
 * Hand-picked 5-star Google reviews shown in the homepage Social Proof section.
 *
 * HOW TO CURATE (copy/paste — there is no per-review API):
 *   1. Open your Google Business listing → Reviews.
 *   2. For each 5-star review you want to feature, copy the fields below.
 *   3. Add a new object to the `curatedReviews` array (keep `rating: 5`).
 *   4. `date` is free text — use Google's wording (e.g. "2 weeks ago") or a month/year.
 *   5. `authorPhoto` and `sourceUrl` are optional; leave as '' if unused.
 *
 * The live overall rating + review count are pulled from Google automatically;
 * these cards are the curated highlight reel.
 */

export interface CuratedReview {
    readonly author: string;
    /** Always 5 for the social proof wall. */
    readonly rating: number;
    readonly text: string;
    /** Free-text date, e.g. "March 2026" or "3 weeks ago". */
    readonly date: string;
    /** Optional reviewer avatar URL. */
    readonly authorPhoto?: string;
    /** Optional link back to the review/listing on Google. */
    readonly sourceUrl?: string;
}

export const curatedReviews: readonly CuratedReview[] = [
    {
        author: 'Roger Gambotto',
        rating: 5,
        text: 'Wow, what an experience! Literally one of the best things to do when in Cairns and our pilot Ben not only made us feel safe, he was incredibly informative about the reef and the coastline. So I got to learn a lot and have a breathtaking experience at the same time.',
        date: '4 months ago',
        authorPhoto:
            'https://lh3.googleusercontent.com/a/ACg8ocJzwNjgEB5xuZvgEALUmozHBvXrOj-vGAfcPL3C4UsJgqFjww=s128-c0x00000000-cc-rp-mo',
        sourceUrl: 'https://www.google.com/maps/contrib/116331912757263291122/reviews',
    },
    {
        author: 'Kelly Dayana Cañaveral Rangel',
        rating: 5,
        text: 'The best experience! ✨ I flew over the Great Barrier Reef with GSL Aviation and it was simply unforgettable. Even though I reached out last minute, they went above and beyond to make it happen. I’m so grateful they found a spot for me! Truly a dream come true 💙 Highly recommend!',
        date: '3 months ago',
        authorPhoto:
            'https://lh3.googleusercontent.com/a-/ALV-UjW3X3owWqQP7XoIW3-lr9zvBpdwr48RGkwViqGTrxNh_4KCQhbq=s128-c0x00000000-cc-rp-mo',
        sourceUrl: 'https://www.google.com/maps/contrib/101934268839540483889/reviews',
    },
    {
        author: 'Ashley B',
        rating: 5,
        text: 'Absolutely worth every single penny! The whole experience was seamless and well-organized, but the real star? The views. Seeing the entire reef system from the air was breathtaking on another level — the colors, the patterns, the sheer size left me speechless. If you’re on the fence, do it. You won’t regret it.',
        date: '9 months ago',
        authorPhoto:
            'https://lh3.googleusercontent.com/a-/ALV-UjXAmtJBvPbajA8MnuWX4DA1ApLV-Ah4W1zL9EWpitCTkZp3XsfF=s128-c0x00000000-cc-rp-mo',
        sourceUrl: 'https://www.google.com/maps/contrib/111922803848368444812/reviews',
    },
];
